export default {
  INITIAL: 'initial',
  PLAY_REQUESTED: 'play-requested',
  PLAYING: 'playing',
  PAUSE_REQUESTED: 'pause-requested',
  PAUSED: 'paused',
  ENDED: 'ended',
};



// WEBPACK FOOTER //
// ./src/widget/constants/video-playback-status.js